import useProfile from "hooks/useProfile";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { updateProfileDataRequest } from "services/userFlagsService";
import { editUsersFlag } from "store/user";

const CraftIdentityHint = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {isLogged , flags} = useProfile();
  const {has_identity_crafting_demo} = flags;

  const callback = (data) => {
    const {action, type} = data;
    if (action === 'next') {
      navigate('/tutorial/craft-identity')
    } else if(action === 'close' && type === 'step:after') {
      dispatch(editUsersFlag({field: 'has_identity_crafting_demo', value: false}))
      updateProfileDataRequest({flags: {indentitycraftingdemo: false}});
    }
  };

  if (isLogged && has_identity_crafting_demo) {
    return <p>aaa</p>
  } else return null
};

export default CraftIdentityHint;
